export const readCache = (key, fallback = null) => {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const cacheHasData = key => localStorage.getItem(key) !== null;

// Menghindari write localStorage dan render React jika isi respons tidak berubah.
export const updateCacheIfChanged = (key, nextValue) => {
  const serialized = JSON.stringify(nextValue);
  if (localStorage.getItem(key) === serialized) return false;
  localStorage.setItem(key, serialized);
  return true;
};
